export const ANTHRAZIT = '#1a1d24';

export type StatusPillEntry = { label: string; klasse: string };
export type PrioPillEntry = { label: string; klasse: string; punkt: string };

export const STATUS_PILL: Record<string, StatusPillEntry> = {
  neu:                        { label: 'Neu',              klasse: 'bg-sky-50 text-sky-600' },
  offen:                      { label: 'Offen',             klasse: 'bg-sky-50 text-sky-600' },
  in_bearbeitung:              { label: 'In Bearbeitung',    klasse: 'bg-amber-50 text-amber-600' },
  warten_auf_rueckmeldung:     { label: 'Warte auf Mieter',  klasse: 'bg-blue-50 text-blue-600' },
  warten_auf_dienstleister:    { label: 'Warte auf DL',      klasse: 'bg-violet-50 text-violet-600' },
  eskaliert:                   { label: 'Eskaliert',         klasse: 'bg-purple-50 text-purple-600' },
  erledigt:                    { label: 'Erledigt',          klasse: 'bg-emerald-50 text-emerald-600' },
  geschlossen:                 { label: 'Geschlossen',       klasse: 'bg-gray-50 text-gray-600' },
};

export const PRIO_PILL: Record<string, PrioPillEntry> = {
  kritisch: { label: 'Kritisch', klasse: 'bg-red-50 text-red-600',       punkt: 'bg-red-500' },
  hoch:     { label: 'Hoch',     klasse: 'bg-orange-50 text-orange-600', punkt: 'bg-orange-500' },
  mittel:   { label: 'Mittel',   klasse: 'bg-amber-50 text-amber-600',   punkt: 'bg-amber-500' },
  niedrig:  { label: 'Niedrig',  klasse: 'bg-gray-50 text-gray-600',     punkt: 'bg-gray-400' },
};

export function statusPill(status: string): StatusPillEntry {
  return STATUS_PILL[status] ?? { label: status, klasse: 'bg-gray-100 text-gray-500' };
}

export function prioPill(prio: string): PrioPillEntry {
  return PRIO_PILL[prio] ?? { label: prio, klasse: 'bg-gray-100 text-gray-500', punkt: 'bg-gray-400' };
}
